/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Router configuration for ReportsConstructor
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { IAppRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const ReportsConstructorRouteConfiguration: IAppRouterConfiguration[] = [
    {
        path: RoutePath.reportsConstructor,
        breadCrumbs: [EBreadCrumbType.reportsConstructor],
    },
    {
        path: RoutePath.reportsConstructorFromAccount,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.reportsConstructorFromAccount,
        ],
    },
    {
        path: RoutePath.reportsConstructorFromAccountList,
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.reportsConstructorFromAccountList],
    },
    {
        path: RoutePath.reportsConstructorFromMobileList,
        breadCrumbs: [EBreadCrumbType.subscriberMobile, EBreadCrumbType.reportsConstructorFromMobileList],
    },
    {
        path: RoutePath.reportsConstructorFromAutoReports,
        breadCrumbs: [EBreadCrumbType.settingsAutoReports, EBreadCrumbType.reportsConstructorFromAutoReports],
    },
];
